import { fromJS } from 'immutable';
import * as constants from './constants';
import R from 'ramda';

const initialState = fromJS({
  viewBy: 'user',
  editedUser: {},
  originalUser: {}, // original version of editedUser
  acctAdmin: {},
  locationSort: [],
  updateUserError: '',
  usersArray: [],
  admin: [], // teams
  contracting: [], // teams

  // dialogs
  addingNewUserDialog: false,
  editUserDialog: false,

  // loaders
  addingNewUser: false,
  gettingUsers: false,
  updatingUser: false,
  deletingUser: false,
  gettingAdmin: false,
  approvingRejectingUser: false,
});

export default function userManagement(state = initialState, { type, payload }) {
  switch (type) {
    case constants.UPDATE_UM_PROP:
      return state.merge(fromJS(payload));
    case constants.ADD_USER_STARTING:
      return state.set('addingNewUser', true);
    case constants.ADDED_USER:
      return state.set('addingNewUser', false)
                  .merge(fromJS(payload));
    case constants.ADD_USER_FAILED:
      return state.set('addingNewUser', false);
    case constants.GETTING_USERS_BY_FILTER:
      return state.set('gettingUsers', true);
    case constants.GOT_USERS_BY_FILTER:
      return state.set('gettingUsers', false)
                  .merge(fromJS(payload));
    case constants.GETTING_USERS_BY_FILTER_FAILED:
      return state.set('gettingUsers', false);
    case constants.UPDATE_USER_STARTING:
      return state.set('updatingUser', true);
    case constants.UPDATED_USER:
      return state.set('updatingUser', false)
                  .merge(fromJS(payload));
    case constants.UPDATE_USER_FAILED:
      return state.set('updatingUser', false)
                  .set('updateUserError', payload.error);
    case constants.DELETE_USER_STARTING:
      return state.set('deletingUser', true);
    case constants.DELETE_USER_FAILED:
      return state.set('deletingUser', false);
    case constants.DELETED_USER:
      const viewBy = state.get('viewBy');
      const filterForPayload = list => list.filter(obj => obj.get('userId') !== payload);
      if (R.equals(viewBy, 'location')) return state.update('locationSort', filterForPayload).set('deletingUser', false);
      if (R.equals(viewBy, 'user')) return state.update('usersArray', list => list.filter(obj => obj.get('_id') !== payload)).set('deletingUser', false);
      return state.update('admin', filterForPayload)
                  .update('contracting', filterForPayload)
                  .set('deletingUser', false);
    case constants.GETTING_COMP_ADMIN:
      return state.set('gettingAdmin', true);
    case constants.GOT_COMP_ADMIN:
      return state.set('gettingAdmin', false)
                  .set('acctAdmin', fromJS(payload));
    case constants.GETTING_COMP_ADMIN_FAILED:
      return state.set('gettingAdmin', false);
    case constants.APPROVE_REJECT_USER_STARTED:
      return state.set('approvingRejectingUser', true);
    case constants.APPROVE_REJECT_USER_DONE:
      return state.set('approvingRejectingUser', false)
                  .set('usersArray', fromJS(payload.usersArray));
    case constants.APPROVE_REJECT_USER_FAILED:
      return state.set('approvingRejectingUser', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/settings/userManagement/reducer.js